export default __webpack_public_path__ + "static/logo-7c4a20190df0c5fd77c6171faa67ca67.svg";